<template>
    <form :action="public_url + '/student-requests/confirm-reservation'">
        <div v-html="formInputs"></div>
        <input v-if="compare_offer" type="hidden" name="compare_offer" value="1">

        <div class="text-center" style="width: fit-content; display: inline-block;">
            <button class="btn book-now-btn">{{ tra.book_now }}</button>
            <br>
            <button @click="compare_offer = true" class="compare-price-btn">{{ tra.compare_price_offer_btn }}</button>
        </div>
    </form>
</template>

<script>

export default {
    components: {

    },
    props: ['base_url', 'formInputs', 'tra'],
    data() {
        return {
            csrf_token: window.csrf_token,
            compare_offer: false,
            public_url: window.public_url
        };
    },
    methods: {

    },

    mounted() {
        
    },
};
</script>
<style scoped> 
.book-now-btn {
    background-color: #009994;
    color: white;
    border-radius: 10px;
    padding: 7px 40px;
    font-size: 20px;
}

.compare-price-btn{
    background-color: transparent;
    border:none;
    border-bottom: 2px solid #009994;
    color: #009994;
    font-size: 17px;
    font-weight: 700;
    margin-top: 10px;
}
</style>